import { Component } from "@angular/core";
import {AlertController, App, LoadingController, NavController, NavParams, ViewController} from "ionic-angular";
import {AppDialog} from "../../component/appDialog";
import {UserService} from "../../services/user.services";
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    templateUrl: 'promoMsg.html',
    selector: 'promo-msg'
})

export class PromoMsgPage {
    private listPromoMsg: any = [];
    content: any;
    constructor(private params: NavParams, private userService: UserService, private alertCtrl: AlertController,private sanitizer: DomSanitizer) {
        console.log("data = ",this.params.get('data'));
        
        this.listPromoMsg = this.params.get('data');
        console.log("this.listPromoMsg:",this.listPromoMsg);
    }

    goDetail(id: any) {
        let postData = { id: id };
        let item = this.listPromoMsg.filter(x=>x.id===id)[0];
        let alertNoti = this.alertCtrl.create({
            title: item.title,
            buttons: ['OK'],
            //message: this.sanitizer.bypassSecurityTrustHtml(item.content) as string,
            message: item.content,
            cssClass: 'alertNoti'
        });
        alertNoti.present();
/*         this.userService.sysMsgBeanInfo(postData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                let alertNoti = this.alertCtrl.create({
                    title: data["sysmsg"]["title"],
                    buttons: ['OK'],
                    message: data["sysmsg"]["content"],
                    cssClass: 'alertNoti'
                });
                alertNoti.present();
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        }); */
    }
}


// WEBPACK FOOTER //
// ./src/pages/promoMsg/promoMsg.ts